import ButtonBase from '@zenbusiness/zui/ButtonBase';
import { superstyled } from '@zenbusiness/zui/styles';

export const StyledButtonBase = superstyled({
  tag: ButtonBase,
  name: 'CookiePreferences',
  slot: 'StyledButtonBase',
  styles: ({ theme }) => ({
    color: theme.palette.info.main,
    textDecoration: 'underline',
  }),
});
